import React, { useEffect, useState, useRef } from "react";
import { Tabs } from "antd";
import { AgGridReact } from "ag-grid-react/lib/agGridReact";
import { error, openNotification, success, warning } from "swfrontend/COMS/NotificationMessageMapping";
import ListFooter from "swfrontend/MDM/MDMScreens/ListView/ListFooter.js";
import { localStorageVariableName, route_url } from "swfrontend/AppConfigs";
import {
  notificationMessage,
  openNotificationType,
  notificationTitle,
} from "swfrontend/MDM/MDMUIConfigs/MDMUIMappings";
import ListHeader from "swfrontend/MDM/MDMScreens/ListView/ListHeader";
import MaterialListCellButton from "./Components/MaterialListCellButton";
import { MATERIAL_APP, MATERIAL_LIST_COLUNMN_DEFS, MATERIAL_MODEL, NOTIFICATION_MEESAGES, } from "../../Constants";
import { DataProvider } from "../../DataProvider";
import { excel_export_api_call } from "swfrontend/COMS/Utils/ApiCommunicaton";
import { CREATE_EXCEL_DATA, EXCEL_FILE_DOWNLOAD } from "../../Helper";

let gridApi = null;
const dataProvider = new DataProvider();
const loggedinUser = localStorage.getItem(localStorageVariableName.userName);
const onFirstDataRendered = (params) => params.api.sizeColumnsToFit();
const onGridReady = (params) => {
  gridApi = params.api;
};

const AllMaterial = ({ history }) => {
  const gridRef = useRef();
  const [state, setState] = useState({
    selectedRow: null,
    rowData: null,
    pageSize: 20,
    searchQuery: null,
    filterQuery: null,
    total: 0,
    currentPage: 1,
  });

  useEffect(() => {
    fetchGridData(state.currentPage);
  }, [state.currentPage, state.searchQuery, state.filterQuery]);

  const onPaginationChange = (page, pageSize) => {
    if (page === 0 || page === null) {
      page = 1;
    }
    gridApi.showLoadingOverlay();
    setState({ ...state, pageSize: pageSize, currentPage: page });
  };

  const onSelectionChanged = () => {
    let selectedRows = gridApi.getSelectedRows();
    setState({ ...state, selectedRow: selectedRows });
  };

  const fetchGridData = (pageNo) => {
    let values = "";
    if (pageNo !== null) {
      values = "?page=" + pageNo;
    }

    if (state.pageSize !== null) {
      values += "&pageSize=" + state.pageSize;
    }

    if (state.searchQuery !== null) {
      values += "&" + state.searchQuery;
    }

    if (state.filterQuery !== null) {
      values += "&filter=1&" + state.filterQuery;
    }

        dataProvider.getPackageList(values)
      .then((res) => {
        if (res.ok) {
          res.json().then((rowData) => {
            try {
              gridApi.hideOverlay();
            } catch (e) {}
            setState({
              ...state,
              total: rowData.total,
              rowData: rowData.results,
            });
          });
        } else {
          res.json().then((responseJson) => {
            openNotification("error", "Error", responseJson["message"]);
          });
        }
      })
      .catch(() => {
        openNotification(
          openNotificationType.error,
          notificationTitle.api,
          notificationMessage.apiConnectionError
        );
      });
  };

  const handleExcelExport = () => {
    if (state.selectedRow == null || state.selectedRow.length === 0) {
      excelDownload("all");
    } else {
      excelDownload(null);
    }
  };

  const excelDownload = (allExport) => {
    let data = CREATE_EXCEL_DATA(
      allExport,
      state.searchQuery,
      state.filterQuery,
      state.selectedRow
    );
    allExport
      ? warning(NOTIFICATION_MEESAGES.WARNNIG_ALL_EXCEL_EXPORT)
      : warning(NOTIFICATION_MEESAGES.WARNNIG_SELECTED_EXCEL_EXPORT);
    excel_export_api_call(MATERIAL_APP, MATERIAL_MODEL, data).then((res) => {
      if (res.ok) {
        if (res.status === 204) {
          success(NOTIFICATION_MEESAGES.SUCCESS_EMAIL_EXCEL_EXPORT);
        } else {
          res.blob().then((blob) => {
            EXCEL_FILE_DOWNLOAD(blob);
            setState({ ...state, selectedRow: null });
          });
          success(NOTIFICATION_MEESAGES.SUCCESS_EXCEL_EXPORT);
        }
      } else {
        error(NOTIFICATION_MEESAGES.ERROR_EXCEL_EXPORT);
      }
    });
  };

  const cellLinkButtonClick = (e) => {
    history.push(route_url.url + "/ViewPackage/" + e.package_no);
  };

  const handleNewButtonClick = () => {
        history.push(route_url.url + '/NewPackage');
  };

  const handleFilterApply = (querystring) => {
    gridApi.showLoadingOverlay();
    setState({ ...state, filterQuery: querystring, currentPage: 1 });
  };

  const handleResetFilter = () => {
    gridApi.showLoadingOverlay();
    setState({
      ...state,
      filterQuery: null,
      currentPage: 1,
    });
  };

  const handleResetSearch = () => {
    gridApi.showLoadingOverlay();
    setState({ ...state, searchQuery: null });
  };

  const handleSearchApply = (value) => {
    gridApi.showLoadingOverlay();
    let quer_param = "search=" + value;
    if (value === "") {
      quer_param = null;
    }
    setState({ ...state, searchQuery: quer_param, currentPage: 1 });
  };

  let gridHeight = window.innerHeight - 400 + "px";
  MATERIAL_LIST_COLUNMN_DEFS.map((column, index) => {
    if (["package_no"].includes(column.field)) {
            column['cellRendererParams'] = { cellLinkButtonClick: cellLinkButtonClick }
    }
  });

  let grid = (
    <AgGridReact
      ref={gridRef}
      columnDefs={MATERIAL_LIST_COLUNMN_DEFS}
      rowData={state.rowData}
      pagination={false}
      onGridReady={onGridReady}
      onFirstDataRendered={onFirstDataRendered}
      onSelectionChanged={onSelectionChanged}
      frameworkComponents={{
        MaterialListCellButton,
      }}
    ></AgGridReact>
  );

  return (
    <div className="col-md-12">
      <ListHeader
        excelExport={() => handleExcelExport()}
        showListHeader={true}
        addButton={true}
        addFilters={true}
        columnFilterButton={false}
        columnDefs={[]}
        onSearch={(q) => handleSearchApply(q)}
        onFilter={(q) => handleFilterApply(q)}
        onResetSearch={() => handleResetSearch()}
        onResetFilter={() => handleResetFilter()}
        addField={handleNewButtonClick}
      />
      <div className="grid-background">
        <div className="row">
          <div className="col-md-12">
            <div
              id="grid"
              className="table-responsive table-bordered table table-hover table-bordered results ag-theme-balham gridViewDisplay"
              style={{ height: gridHeight }}
            >
              {grid}
            </div>
          </div>
        </div>
      </div>
      <div>
        <ListFooter
          total={state.total}
          currentPage={state.currentPage}
          onShowSizeChange={(pageNo, pageSize) =>
            onPaginationChange(pageNo, pageSize)
          }
          onPaginationChange={(pageNo, pageSize) =>
            onPaginationChange(pageNo, pageSize)
          }
        />
      </div>
    </div>
  );
};

export default AllMaterial;
